/* AutoShineX — PDP "Buy now" wiring (Shopflo-friendly, ZERO Shop Pay JS).
 * The button itself is rendered SERVER-SIDE in blocks/accelerated-checkout.liquid, so it
 * paints instantly next to Add to cart (no JS injection delay / layout shift). This script
 * only attaches the click behavior: add the selected variant+qty to the cart, then open
 * Shopflo checkout (handleFloBuyNowBtn). We intentionally do NOT use Shopify's dynamic-
 * checkout button (portable-wallets.js 76KB + bypasses Shopflo).
 */
(function () {
  'use strict';

  function mainForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form.shopify-product-form[data-type="add-to-cart-form"]'));
    if (!forms.length) return null;
    var pref = forms.filter(function (f) { return f.closest('.product-information, [class*="product-information"]'); });
    return pref[0] || forms[0];
  }

  function wire(btn) {
    if (!btn || btn.__asxWired) return;
    btn.__asxWired = true;

    btn.addEventListener('click', function () {
      var form = mainForm();
      var idInput = form && form.querySelector('[name="id"]');
      var qtyInput = form && form.querySelector('[name="quantity"]');
      var id = idInput && idInput.value;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (!id) return;

      btn.disabled = true;
      var label = btn.querySelector('span');
      var orig = label ? label.textContent : 'Buy now';
      if (label) label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty }),
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            if (!r.ok) return Promise.reject(data); // 422 (sold out) must fail — never checkout empty
            return data;
          });
        })
        .then(function () {
          if (label) label.textContent = 'Redirecting…';
          // Item is in the cart → go STRAIGHT to Shopflo checkout. Fall back to native only if Shopflo is absent.
          if (typeof window.handleFloBuyNowBtn === 'function') {
            try { window.handleFloBuyNowBtn(); return; } catch (e) {}
          }
          if (window.Shopflo && typeof window.Shopflo.openCheckout === 'function') {
            try { window.Shopflo.openCheckout(); return; } catch (e) {}
          }
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          btn.disabled = false;
          if (label) label.textContent = (err && (err.description || err.message)) ? 'Unavailable' : 'Try again';
          setTimeout(function () { if (label) label.textContent = orig; }, 2200);
        });
    });
  }

  function init() {
    var btn = document.querySelector('.asx-pdp-buynow');
    if (btn) wire(btn);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
